import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "0.6rem",
    fontWeight: 700,
    lineHeight: 1,
    padding: "2px 5px",
    borderRadius: 8,
    color: "#fff",
    backgroundColor: theme.palette.secondary.main,
    marginLeft: 6,
    whiteSpace: "nowrap",
    letterSpacing: "0.3px",
    textTransform: "uppercase",
    animation: "$pulse 2s ease-in-out infinite",
  },
  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.7 },
  },
}));

/**
 * NewBadge - Badge reutilizável para indicar features novas.
 * Fica visível até ser removido do código numa próxima build.
 *
 * Props:
 *   label  - (opcional) texto customizado. Default: i18n "badges.new"
 *   color  - (opcional) cor de fundo customizada
 *   style  - (opcional) estilos adicionais
 */
const NewBadge = ({ label, color, style }) => {
  const classes = useStyles();

  return (
    <span
      className={classes.badge}
      style={{
        ...(color ? { backgroundColor: color } : {}),
        ...style,
      }}
    >
      {label || i18n.t("badges.new")}
    </span>
  );
};

export default NewBadge;
